import { SearchableType } from '../searchableTypeToSnippetVariant';
import { IContent } from '@/@types/cms';
import { Variant } from '@/redux/slices/pdpSlice';
import { useGetAllChildren } from '@/hooks/useGetAllChildren';
import { ItemAnalyticsModel, ItemListAnalyticsModel } from '@/@types/client-api';
import { AnalyticsContext } from '@/analytics/constants';

export type ActionType =
  | 'BuyNow'
  | 'StartWatching'
  | 'Register'
  | 'ViewRegistration'
  | 'ChangeOrCancelRegistration';

export type EcommPanelParams = {
  pk: string;
  url: string;
  title: string;
  searchableType: SearchableType | null;
  guidValue: string | null;
  action: ActionType;
  initialVariantSelector?: (variants: Variant) => boolean;
  creditTrackerCode?: string;
  itemAnalyticsModel?: ItemAnalyticsModel;
  context?: AnalyticsContext;
  listId?: string;
  listName?: string;
  itemListAnalyticsModel?: ItemListAnalyticsModel;
};

type UseEcommPanelDataReturn = {
  data?: IContent[];
  isLoading: boolean;
  isError: boolean;
};

const useEcommPanelData = (params?: EcommPanelParams): UseEcommPanelDataReturn => {
  const { guidValue } = params || {};

  const {
    children,
    isLoading: isLoadingChildren,
    isApiError
  } = useGetAllChildren({
    contentLink: guidValue ?? undefined,
    enableWMSPrice: 'all'
  });

  const isLoading = isLoadingChildren;

  return { data: children, isLoading, isError: !!isApiError };
};

export default useEcommPanelData;
